/**
 * Id of the element React mounts the app into.
 *
 * @since 1.3.0
 */
export const APP_ROOT_ID = 'fkwd-root';

/**
 * Id of the routed page's main landmark, the skip link's target and the fallback for focus.
 *
 * @since 1.3.0
 */
export const MAIN_ELEMENT_ID = 'fkwd-main';

/**
 * Id of the sidebar, so the narrow-layout menu button can name what it controls.
 *
 * @since 1.3.0
 */
export const NAV_ELEMENT_ID = 'fkwd-nav';
